import React from "react";

// A seamless CSS marquee. Renders children twice for a -50% loop.
export function Marquee({ children, className = "", speed = "animate-marquee", reverse = false, pauseOnHover = true }) {
  const anim = reverse ? "animate-marquee-reverse" : speed;
  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      <div className={`flex w-max ${anim} ${pauseOnHover ? "hover:[animation-play-state:paused]" : ""}`}>
        <div className="flex shrink-0">{children}</div>
        <div className="flex shrink-0" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
}
